import Stack from "@mui/material/Stack";
import IsocronasMapTravelTimeAction from "./IsocronasMapTravelTimeAction";
import IsocronasMapTransportAction from "./IsocronasMapTransportAction";
import Divider from "@mui/material/Divider";
import IsocronasMapSelectPointAction from "./IsocronasMapSelectPointAction";
import Grid from "@mui/material/Grid";
import IsocronasFilterHelper from "./IsocronasFilterHelper";

const IsocronasFilterSelector = () => {
    return (
        <>
            <Stack spacing={1} sx={{p: 1}}>
                <Stack direction="row" justifyContent="space-between" spacing={1}>
                    <IsocronasMapSelectPointAction />
                </Stack>
                <Stack direction="row" justifyContent="center" spacing={3}>
                    <IsocronasMapTransportAction />
                    <IsocronasMapTravelTimeAction />
                </Stack>
                <IsocronasFilterHelper />
            </Stack>
            <Divider />
        </>
    );
};

export default IsocronasFilterSelector;
